import Vue from 'vue';

export function getGeographyList() {
  return Vue.axios({
    url: '/carton/getGeography',
  });
}

export function getByNodeId(params) {
  return Vue.axios({
    url: '/carton/getByNodeId',
    params,
  });
}

export function createCarton(data) {
  return Vue.axios({
    url: '/carton/create',
    method: 'post',
    data,
  });
}

export function getCartonList(params) {
  return Vue.axios({
    url: '/carton/list',
    params,
  });
}

export function getCarton(params) {
  return Vue.axios({
    url: '/carton/getCarton',
    params,
  });
}

export function deleteCarton(params) {
  return Vue.axios({
    url: '/carton/delete',
    params,
  });
}

export function batchUpdateCarton(data) {
  return Vue.axios({
    url: '/carton/batch/update',
    method: 'post',
    data,
  });
}

export function addOrderToCarton(data) {
  return Vue.axios({
    url: '/carton/addOrder',
    method: 'post',
    data,
  });
}

export function removeCartonOrder(data) {
  return Vue.axios({
    url: '/carton/remove/order',
    method: 'post',
    data,
  });
}

export function getCartonOrderList(data) {
  return Vue.axios({
    url: '/shipOrder/cartonOrder/list',
    method: 'post',
    data,
  });
}

export function getShipOrderList(data) {
  return Vue.axios({
    url: '/shipOrder/list',
    method: 'post',
    data,
  });
}

export function downloadInvoiceSample(params) {
  return Vue.axios({
    url: '/shipOrder/sample',
    responseType: 'blob',
    params,
  });
}

export function getUploadStatus(params) {
  return Vue.axios({
    url: '/shipOrder/getFlag',
    params,
  });
}

export function saveInvoice(data) {
  return Vue.axios({
    url: '/shipOrder/invoice',
    method: 'post',
    data,
  });
}

export function getOSSConfig() {
  return Vue.axios({
    url: '/oss/file-upload-auth-sts',
  });
}

export function uploadImg(data) {
  return Vue.axios({
    url: '/oss/upload/file',
    method: 'post',
    data,
  });
}

export function uplaodFile(data) {
  return Vue.axios({
    url: '/shipOrder/uploadFile',
    method: 'post',
    data,
  });
}

export function getAwbNum(params) {
  return Vue.axios({
    url: '/shipOrder/getAwbNum',
    params,
  });
}

export function getDownLoadData(params) {
  return Vue.axios({
    url: '/shipOrder/getDownLoadData',
    params,
  });
}

export function getAWBResult(params) {
  return Vue.axios({
    url: '/shipOrder/awb/result',
    params,
  });
}

export function getPackingListData(params) {
  return Vue.axios({
    url: '/shipOrder/packingList',
    params,
  });
}

export function saveAwbInfo(data) {
  return Vue.axios({
    url: '/shipOrder/saveAwbInfo',
    method: 'post',
    data,
  });
}

export function updateShipmentById(params) {
  return Vue.axios({
    url: '/shipOrder/updateShipmentById',
    params,
  });
}

export function downloadAWB(params) {
  return Vue.axios({
    url: '/shipOrder/awb',
    responseType: 'blob',
    params,
  });
}
